export default __webpack_public_path__ + "static/media/ankrBNB.964fb783.svg";